<template>
  <div class="meifuList">

    <Modal class="common-drawer newModal" v-model="showInDrawer" title="经销商用户" width="480px" :mask-closable="false" @on-cancel="closeDrawer" class-name="vertical-center-modal">
      <div >
        <Form ref="formValidate" :model="formData" :rules="ruleValidate" label-position="top">
          <FormItem label="姓名" prop="nickname">
            <Input v-model="formData.nickname" placeholder="请输入" />
          </FormItem>
          <FormItem label="手机号" prop="mobile">
            <Input v-model="formData.mobile" placeholder="请输入" />
          </FormItem>

          <FormItem label="负责客户" prop="consumerTenantIds">
          
            <div class="deimgadd" @click="addinputd">
              <img src="../../../assets/images/add.png" style="width:12px;height:12px" />
              <div class="addinput">分配客户</div>
            </div>
            <div class="consunatest" v-if="caoption.length>0">
              <div class="testItem" v-for="(item,key) in caoption" :key="key">
                <span> {{item.value}}</span>
                <Icon @click="remove(item.id)" class="init-ab" type="ios-close" size="15" />
              </div>
            </div>
            <div class="consunatest" v-else style="padding:0;border:none">
              <Input @on-focus="addinputd" placeholder="请选择" />
            </div>
          </FormItem>

          <FormItem label="备注" prop="remark">
            <Input v-model="formData.remark" type="textarea" :autosize="{ minRows: 2, maxRows: 5 }" placeholder="请输入"></Input>
          </FormItem>
        </Form>
      </div>
      <div class="drawer-footer" slot="footer">
        <Button type="primary" @click="submitForm('formValidate')" :loading="btnLoading">提交</Button>
        <Button style="margin-right: 8px" @click="closeDrawer">取消</Button>
      </div>
    </Modal>
    <Dealermodel @indarr="indarr"
     :clist='arroption' v-model="dwarerShow" />

  </div>
</template>

<script>
  import api from "@/api";
  import ls from "store2";
  import Cselect from "@/components/c-select";
  import Dealermodel from './dealer-model.vue'
  import { isFirstCharacterNotDigit } from "@/util/common.js";
  export default {
    components: {
      Cselect,
      Dealermodel
    },
    props: {
      showDrawer: Boolean,
      closeDrawer: Function,
      getLists: Function,
      curItemDetail: Object,
      tenantId: String,
      customerList: [Object, Array],
      dataCenter: Object,
    },
    computed: {

    },
    data() {
      // const validatePhone = (rule, value, callback) => {
      //     const valueCopy = value.replace(/\s/g, "");
      //     if (valueCopy === "" || /^[0-9]*$/.test(valueCopy) === false) {
      //         callback(new Error("请填写正确的手机号"));
      //     } else {
      //         callback();
      //     }
      // };
      const validatePhone = (rule, value, callback) => {
        if (!value) {
          return callback(new Error("手机号不能为空"));
        // } else if (!/^1[3456789]\d{9}$/.test(value)) {
        //   callback("手机号格式不正确");
        } else {
          callback();
        }
      };
      const validateName = (rule, value, callback) => {
      if (!value) {
        callback(new Error("姓名不能为空"));
      } else if (isFirstCharacterNotDigit(value)) {
        callback(new Error("首个字符不能为数字"));
      } else {
        callback();
      }
    };
      return {
        arroption: [],
        dwarerShow: false,
        caoption: [],
        showInDrawer: false,
        formData: {},
        btnLoading: false,
        formValidate: {
          nickname: "",
          mobile: "",
          remark: "",
          consumerTenantIds: [],
        },
        form: {
          email: "",
          authorityString: "",
          consumerTenantId: "",
          workshopId: "",
          current: "",
          deleted: "",
          gmtCreate: "",
          gmtCreateDateEnd: "",
          gmtCreateDateStart: "",
          gmtModified: "",
          id: "",
          ids: [],
          limit: "",
          page: "",
          size: "",
          status: "",
          version: "",
          workshopIds: [],
        },
        ruleValidate: {
          nickname: [{
             required: true,
            validator: validateName,
            trigger: "blur",
          }, ],
          mobile: [{
            required: true,
            validator: validatePhone,
            trigger: "blur",
          }, ],
        },
      };
    },
    mounted() {},
    methods: {
            addinputd() {
        this.dwarerShow = true
      },
      stopPropagation() {
  
      },
      remove(index){
        
        let caoindex=this.caoption.findIndex(e=>e.id==index)
    
        this.caoption.splice(caoindex,1)
       let arrndex=this.arroption.findIndex((e)=>{
        return e.id==index
       })
       let item=this.arroption[arrndex]
  
       item.bo=false
       this.$set(this.arroption,arrndex,item)
         let workshopindex = this.formData.consumerTenantIds.findIndex(e =>{
            if(e.id&& e.id == index){
                return true
            }else if(e==index){
                 return true
            }
         })
       
        this.formData.consumerTenantIds.splice(workshopindex, 1)

      },
      submitForm(name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            this.btnLoading = true;
            if (!this.formData.id) {
              this.formData.tenantId = this.tenantId;
              this.formData = {
                ...this.formData,
                ...this.form
              };
            }
            api.axss("post", "/ocm-admin/user/edit", this.formData)
              .then((res) => {
                this.btnLoading = false;
                if (res.code === "00000") {
                  this.$Message.success("提交成功");

                  this.formData = {}; // 重置form
                  this.closeDrawer(); // 关闭弹窗
                  this.getLists(); // 刷新列表
                  this.$refs["cslect"].iscancle()
                }
              })
              .catch((error) => {
                this.btnLoading = false;
              });
          }
        });
      },
      reset(key) {
        Object.keys(this[key]).forEach((item) => {
          this[key][item] = "";
        });
      },
      calculation() {
        let arrbo = JSON.parse(JSON.stringify(this.customerList))
     
        let value = this.formData.consumerTenantIds
      
        arrbo = arrbo.map((item) => {
          item.bo = false
          if (value) {
            value.forEach((item1) => {
              if (item['id'] == item1) {
                item.bo = true

              }
            })
          }
          return item
        })
       
       
        let arrfliter = arrbo.filter(e => e.bo)
    
        return {
          arrbo,
          arrfliter
        }
      },
       indarr(data) {
        this.formData.consumerTenantIds = data
        this.$nextTick(() => {
          let {
            arrfliter,
            arrbo
          } = this.calculation()

          this.caoption = arrfliter
         
          this.arroption = arrbo
          this.dwarerShow=false
        })
      

      },
    },
    watch: {
      curItemDetail: {
        handler: function(newValue, oldValue) {
          if (newValue !== oldValue){
            this.$refs.formValidate.resetFields();
          if (newValue.id) {
            this.formData = newValue;
            this.formData.consumerTenantIds =
              newValue.consumerList &&
              newValue.consumerList.map((item) => item.id);
          } else this.formData = {};
          }
          this.$nextTick(() => {
              let {
                arrfliter,
                arrbo
              } = this.calculation()
              this.caoption = this.$c.deepClone(arrfliter)
              this.arroption =  this.$c.deepClone(arrbo)

            })
        },
        deep: true,
      },
      showDrawer: {
        handler: function(newValue, oldValue) {
          this.showInDrawer = newValue;
        },
        deep: true,
      },
    },
  };
</script>

<style lang="less" scoped>
  .consunatest {
    min-height: 32px;
    max-height: 168px;
    overflow: auto;
    padding: 8px 24px 8px 4px;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    outline: none;
    user-select: none;
    cursor: pointer;
    position: relative;
    background-color: #fff;

    border: 1px solid #dcdee2;
    transition: all 0.2s ease-in-out;

    .testItem {
      display: flex;
      align-items: center;
      padding: 4px 12px 3px 12px;
      background: #FAFAFA;
      border-radius: 12px;
      opacity: 1;
      border: 1px solid #DDDDDD;
      font-size: 12px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #595959;
      box-sizing: initial;
      line-height: 1;
      margin-right: 8px;
      margin-bottom: 8px;
    }

  }

  .deimgadd {
    position: absolute;
    right: 0;
    top: -19px;
    display: flex;
    font-size: 12px;
    font-weight: 400;
    color: #0070cc;
    line-height: 8px;

    align-items: center;

    div {
      margin-left: 3px;
      cursor: pointer;
    }
  }
</style>